import { Components, Theme } from '@mui/material';

const muiLink: Components<Theme>['MuiLink'] = {
	styleOverrides: {
		root: ({ theme }) => ({
			color: theme.palette.text.primary,
		}),
	},
	defaultProps: {
		underline: 'hover',
	},
};

export default muiLink;
